import styled from '@emotion/styled';
import type { FC } from 'react';
import { toast } from 'react-toastify';
import { useTrackersForAction } from '../../../lib/customHooks';
import { useStore } from '../../../store/reducers';

export const RemoveTrackerButton: FC = () => {
  const trackersToUse = useTrackersForAction();
  const { removeTrackers, removeAllTrackersFromSample } = useStore((s) => s.trackers.actions);

  if (trackersToUse == null) return <></>;
  const handleRemove = async () => {
    const res = confirm('Do you really want to delete that trackers!');
    if (res) {
      await removeTrackers(trackersToUse.map((t) => t.id));
      removeAllTrackersFromSample();
      toast.info('Removed trackers!');
    }
  };

  return (
    <Container onClick={handleRemove}>
      <div>Remove tracker</div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
